export const getLimits = ({ totalCount, page, pageSize }) => {
  const start = Math.min(totalCount, 1 + (page - 1) * pageSize);
  const end = Math.min(totalCount, Math.max(0, start + pageSize - 1));
  return { start, end };
};
